import React, { useEffect, useState } from 'react';
import Header from './Header';

const Dashboard = ({ userEmail, onLogout, isFirstLogin }) => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(isFirstLogin);

  useEffect(() => {
    // Hide success message after 5 seconds
    const timer = setTimeout(() => {
      setShowSuccessMessage(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <Header 
        showAuthButtons={false}
        showLogout={true}
        onLogout={onLogout}
        userEmail={userEmail}
      />

      {/* Success Message - Only show for 5 seconds */}
      <div style={{
        height: showSuccessMessage ? 'auto' : '0',
        overflow: 'hidden',
        transition: 'height 0.8s ease-in-out, opacity 0.8s ease-in-out',
        opacity: showSuccessMessage ? 1 : 0
      }}>
        <section style={{ 
          padding: '40px 0',
          backgroundColor: '#d4edda',
          borderBottom: '1px solid #c3e6cb',
          animation: showSuccessMessage ? 'fadeInOut 5s ease-in-out' : 'none'
        }}>
          <div className="container text-center">
            <h2 style={{ 
              color: '#155724',
              marginBottom: '10px'
            }}>
              🎉 Authentication Successful!
            </h2>
            <p style={{ color: '#155724' }}>
              You have successfully logged in using EUDI Wallet. You can now proceed with your purchase.
            </p>
          </div>
        </section>
      </div>

      <section style={{
        backgroundColor: '#f8f9fa',
        // transform: showSuccessMessage ? 'translateY(0)' : 'translateY(-120px)',
        transition: 'transform 0.8s ease-in-out'
      }}>
        <div className="container-hero">
          <div style={{
            backgroundImage: `url("/images/living-room-scandinavian-interior-design.jpg")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '400px',
            //borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {/* Optional overlay for better text readability */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              borderRadius: '12px'
            }}></div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ padding: '80px 0', backgroundColor: 'white' }}>
        <div className="container text-center">
          <h2 style={{ 
            fontSize: '36px', 
            marginBottom: '20px',
            color: '#333'
          }}>
            Buy from experts
          </h2>
          <p style={{ 
            fontSize: '18px', 
            color: '#666', 
            marginBottom: '60px',
            maxWidth: '600px',
            margin: '0 auto 60px'
          }}>
            Every month Floors has different plant selections for you to decorate your surroundings!
          </p>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
            gap: '40px',
            maxWidth: '800px',
            margin: '0 auto 60px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: '#90c695',
                borderRadius: '50%',
                margin: '0 auto 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '32px'
              }}>
                🌱
              </div>
              <h3 style={{ marginBottom: '10px', color: '#333' }}>Sustainable processes</h3>
            </div>
            
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: '#90c695',
                borderRadius: '50%',
                margin: '0 auto 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '32px'
              }}>
                💬
              </div>
              <h3 style={{ marginBottom: '10px', color: '#333' }}>Tailored service 24/7</h3>
            </div>
          </div>

          {/* Shopping Actions */}
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: '40px',
            borderRadius: '12px',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            <h3 style={{ marginBottom: '20px', color: '#333' }}>
              Ready to start shopping?
            </h3>
            <p style={{ marginBottom: '30px', color: '#666' }}>
              Browse our exclusive plant collections and create your perfect indoor garden.
            </p>
            <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button className="btn btn-primary" style={{ fontSize: '18px', padding: '15px 30px' }}>
                🛍️ Browse Products
              </button>
              <button className="btn btn-secondary" style={{ fontSize: '18px', padding: '15px 30px' }}>
                📞 Contact Expert
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ 
        backgroundColor: '#1a2332', 
        color: 'white', 
        padding: '60px 0 20px' 
      }}>
        <div className="container">
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
            gap: '40px',
            marginBottom: '40px'
          }}>
            <div>
              <h3 style={{ fontSize: '32px', marginBottom: '20px' }}>F</h3>
              <p style={{ marginBottom: '10px' }}>Floors GmbH</p>
              <p style={{ marginBottom: '10px' }}>Example street, 12 1st floor, Berlin</p>
              <p style={{ marginBottom: '10px' }}>Tel: +00 0000 0000</p>
              <p>Mo-Fr from 9:00 am to 7:00 pm</p>
            </div>
            
            <div>
              <h4 style={{ marginBottom: '20px' }}>About Floors</h4>
              <p style={{ marginBottom: '10px' }}>Blog</p>
              <p style={{ marginBottom: '10px' }}>Our story</p>
              <p>Career</p>
            </div>
            
            <div>
              <h4 style={{ marginBottom: '20px' }}>Legal</h4>
              <p style={{ marginBottom: '10px' }}>Contact</p>
              <p style={{ marginBottom: '10px' }}>Privacy</p>
              <p>Conditions</p>
            </div>
          </div>
          
          <div style={{ 
            borderTop: '1px solid #333', 
            paddingTop: '20px', 
            textAlign: 'center',
            color: '#666'
          }}>
            © 2025
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Dashboard;

